/* global axios */
import ApiClient from './ApiClient';

// Módulo Empreendimentos (vertical imobiliária, fase 1): backend em
// /api/v1/accounts/:account_id/empreendimentos/... — developments (+mirror),
// towers aninhadas, units aninhadas + units/bulk, units avulsas (+reserve/
// release/block/unblock), reservations/:id/extend, brokers e o portal
// singular do corretor.
class EmpreendimentosAPI extends ApiClient {
  constructor() {
    super('empreendimentos/developments', { accountScoped: true });
  }

  // Base sem o sufixo /developments, para os recursos que não são aninhados
  // em um empreendimento (units avulsas, reservations, brokers, broker_portal).
  get base() {
    return this.url.replace(/\/developments$/, '');
  }

  developments() {
    return axios.get(this.url);
  }

  development(id) {
    return axios.get(`${this.url}/${id}`);
  }

  createDevelopment(data) {
    return axios.post(this.url, { development: data });
  }

  updateDevelopment(id, data) {
    return axios.patch(`${this.url}/${id}`, { development: data });
  }

  deleteDevelopment(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  mirror(id) {
    return axios.get(`${this.url}/${id}/mirror`);
  }

  createTower(devId, data) {
    return axios.post(`${this.url}/${devId}/towers`, { tower: data });
  }

  bulkUnits(devId, data) {
    return axios.post(`${this.url}/${devId}/units/bulk`, data);
  }

  unit(id) {
    return axios.get(`${this.base}/units/${id}`);
  }

  updateUnit(id, data) {
    return axios.patch(`${this.base}/units/${id}`, { unit: data });
  }

  // Duas formas: `reserve(unitId, mappingId)` (aba Unidade do negócio, que já
  // tem o id do mapeamento) ou `reserve(unitId, { conversation_id, funnel_id })`
  // (drawer da unidade, onde o usuário informa o ID da conversa da URL do negócio).
  reserve(unitId, mappingIdOrParams) {
    const payload =
      mappingIdOrParams !== null && typeof mappingIdOrParams === 'object'
        ? mappingIdOrParams
        : { conversation_funnel_mapping_id: mappingIdOrParams };
    return axios.post(`${this.base}/units/${unitId}/reserve`, payload);
  }

  release(unitId, reason) {
    return axios.post(`${this.base}/units/${unitId}/release`, { reason });
  }

  block(unitId, reason) {
    return axios.post(`${this.base}/units/${unitId}/block`, { reason });
  }

  unblock(unitId) {
    return axios.post(`${this.base}/units/${unitId}/unblock`);
  }

  extendReservation(id) {
    return axios.post(`${this.base}/reservations/${id}/extend`);
  }

  brokers() {
    return axios.get(`${this.base}/brokers`);
  }

  updateBroker(id, data) {
    return axios.patch(`${this.base}/brokers/${id}`, { broker: data });
  }

  approveBroker(id) {
    return axios.post(`${this.base}/brokers/${id}/approve`);
  }

  blockBroker(id) {
    return axios.post(`${this.base}/brokers/${id}/block`);
  }

  getBrokerPortal() {
    return axios.get(`${this.base}/broker_portal`);
  }

  updateBrokerPortal(data) {
    return axios.patch(`${this.base}/broker_portal`, { broker_portal: data });
  }
}

export default new EmpreendimentosAPI();
